module.exports = __webpack_public_path__ + "static/media/biography.4d70e790.jpg";